import { gql } from '@apollo/client';

export const Relais = {
  fragments: {
    relais: gql`
      fragment RelaisMainInfo on Relais {
        adresse1
        adresse2
        adresse3
        codePostal
        localite
        identifiant
        nom
        coordGeolocalisationLatitude
        coordGeolocalisationLongitude
      }
    `
  }
};
